// ─── Lecture d'un tableau AFFICHÉ → colonnes et lignes pour Excel ──────────
// Sert au menu du clic droit (MenuBloc.js). Le résultat est ce que l'écran
// montre (filtres, maille, lignes dépliées) : rien hors du périmètre de la
// personne. Les montants arrondis à l'écran (k€, M€) le sont aussi ici.

// Éléments décoratifs à ne pas recopier dans une cellule : étiquettes,
// chevrons de dépliage, boutons.
const DECOR = '[class*="-tag"], [class*="-we"], .chev, button, svg, .hint';
const ESPACES = /[\s  ]+/g;

// Les morceaux d'une cellule (nom, badge, sous-ligne) sont séparés par « · » :
// textContent les collerait (« SOGUAVASOREC2Guadeloupe »).
export function texte(cellule) {
  const c = cellule.cloneNode(true);
  c.querySelectorAll(DECOR).forEach((e) => e.remove());
  const morceaux = [];
  const w = document.createTreeWalker(c, NodeFilter.SHOW_TEXT);
  while (w.nextNode()) { const t = w.currentNode.nodeValue.replace(ESPACES, ' ').trim(); if (t) morceaux.push(t); }
  return morceaux.join(' · ').replace(/ · ([·%€])/g, ' $1');
}

// « 1 234 € », « 25 k€ », « 1,2 M€ », « 12,5 % », « −3 » → nombre ; le reste
// reste du texte. Les montants arrondis à l'écran (k€) le sont aussi ici.
export function nombre(t) {
  const m = t.match(/^([+\-−]?)\s*([\d\s  ]*\d(?:,\d+)?)\s*(k€|M€|€|%|pt|h|j)?$/);
  if (!m) return null;
  const n = Number(m[2].replace(ESPACES, '').replace(',', '.'));
  if (!Number.isFinite(n)) return null;
  const mult = m[3] === 'k€' ? 1e3 : m[3] === 'M€' ? 1e6 : 1;
  return (m[1] === '-' || m[1] === '−' ? -1 : 1) * n * mult;
}

// En-têtes : la dernière ligne de <thead> donne les colonnes ; une ligne de
// groupes au-dessus (colspan) préfixe leur libellé.
export function entetes(table) {
  const lignes = [...table.querySelectorAll('thead tr')];
  if (!lignes.length) return null;
  const grille = lignes.map((tr) => {
    const out = [];
    [...tr.children].forEach((c) => { for (let k = 0; k < (c.colSpan || 1); k++) out.push(texte(c)); });
    return out;
  });
  const base = grille[grille.length - 1];
  const libelles = base.map((l, i) => {
    const groupes = grille.slice(0, -1).map((g) => g[i]).filter((g) => g && g !== l);
    return [...groupes, l].filter(Boolean).join(' — ') || `Colonne ${i + 1}`;
  });
  // « vs N-1 », « Écart »… disent à quoi ils se rapportent : la colonne d'avant.
  return libelles.map((l, i) => (i > 0 && /^(vs|écart|Δ|évol)/i.test(l) ? `${libelles[i - 1]} ${l}` : l));
}

export function lire(table) {
  const corps = [...table.querySelectorAll('tbody tr, tfoot tr')]
    .map((tr) => [...tr.children].map(texte))
    .filter((l) => l.some((v) => v));
  const largeur = Math.max(0, ...corps.map((l) => l.length));
  const tetes = entetes(table) || Array.from({ length: largeur }, (_, i) => `Colonne ${i + 1}`);
  const colonnes = tetes.map((l, i) => {
    const valeurs = corps.map((r) => r[i]).filter((v) => v && v !== '—' && v !== '·');
    const num = valeurs.length > 0 && valeurs.every((v) => nombre(v) != null);
    return {
      l, type: num ? 'nombre' : 'texte', largeur: i === 0 ? 30 : 16,
      v: (r) => { const v = r[i]; if (!v || v === '—' || v === '·') return null; return num ? nombre(v) : v; },
    };
  });
  return { colonnes, lignes: corps };
}

export const rapportDe = () => (document.querySelector('main h1') || {}).textContent || document.title || 'A97 BI';
export const nomPropre = (s) => s.replace(/[\\/:*?[\]"<>|]/g, ' ').replace(ESPACES, ' ').trim();

